import { render } from "./CourseProgress.vue?vue&type=template&id=0aa4b29c&scoped=true"
import script from "./CourseProgress.vue?vue&type=script&lang=js"
export * from "./CourseProgress.vue?vue&type=script&lang=js"

import "./CourseProgress.vue?vue&type=style&index=0&id=0aa4b29c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa4b29c"]])

export default __exports__